import { render, staticRenderFns } from "./DpadForm2.vue?vue&type=template&id=6f2ee065"
import script from "./DpadForm2.vue?vue&type=script&lang=js"
export * from "./DpadForm2.vue?vue&type=script&lang=js"
import style0 from "./DpadForm2.vue?vue&type=style&index=0&id=6f2ee065&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports